import GetWidgetClassesRequestModelBase from '../_generated/modelBases/get-widget-classes-request-model-base';

export default class GetWidgetClassesRequestModel extends GetWidgetClassesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
